// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-buttons {
  display: flex;
  justify-content: center;
      flex-wrap: wrap;
}

.csshome-buttons {
  width: 15rem;
  margin: 3rem;
  height: 15rem;
  border-radius: 15px;
  background-color: black;
  color: white;
  font-size: 1.5rem;
}

.svg-icons-home {
  color: red;
}

.csshome-buttons:hover {
  background-color: white;
  color: black;
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;MACnB,eAAe;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":[".home-buttons {\n  display: flex;\n  justify-content: center;\n      flex-wrap: wrap;\n}\n\n.csshome-buttons {\n  width: 15rem;\n  margin: 3rem;\n  height: 15rem;\n  border-radius: 15px;\n  background-color: black;\n  color: white;\n  font-size: 1.5rem;\n}\n\n.svg-icons-home {\n  color: red;\n}\n\n.csshome-buttons:hover {\n  background-color: white;\n  color: black;\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
